import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { ButtonComponent, ButtonType } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  imports: [
    TranslateDirective,
    ButtonComponent,
    IconComponent
  ],
  selector: 'td-wb-view-more',
  templateUrl: 'view-more.component.html'
})
export class ViewMoreComponent {
  readonly buttonId: InputSignal<string | undefined> = input<string | undefined>(undefined);
  readonly viewLess: InputSignal<boolean> = input<boolean>(false);
  readonly buttonType: InputSignal<ButtonType> = input<ButtonType>('tertiary');
  readonly size: InputSignal<string | undefined> = input<string | undefined>(undefined);
  readonly clicked: OutputEmitterRef<void> = output<void>();

  protected showViewLess: boolean = false;

  protected onClick(): void {
    if (this.viewLess()) {
      this.showViewLess = !this.showViewLess;
    }
    this.clicked.emit();
  }
}
